import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.createMeeting.label",
    defaultMessage: "Create booking",
    description: "Create meeting button label",
  },
});
